export const navigationLinks = [
  { href: "#co-otrzymasz", label: "Oferta" },
  { href: "#co-zyskasz", label: "Korzyści" },
  { href: "#wszystkie-kursy", label: "Kursy" },
  { href: "#opinie", label: "Opinie" },
  { href: "#kontakt", label: "Kontakt" },
] as const;